module.exports = __webpack_public_path__ + "img/background_top_overlay.82a50619.png";